import axios from 'axios';

export default {
  set_configuration({ commit }) {
    axios.get('./php/api.php').then(response => {
      commit('SET_CONFIGURATION', response.data);
    });

    axios
      .get('./Configurations/social.json')
      .then(response => commit('SET_SOCIAL', response.data));
  },
  set_configurator({ commit }, payload) {
    commit('SET_CONFIGURATOR', payload);
  },
  set_active({ commit }, payload) {
    commit('SET_ACTIVE', payload);
  },
  change_combination({ commit }, payload) {
    commit('CHANGE_COMBINATION', payload);
  },
  set_social_url({ commit }, payload) {
    commit('SET_SOCIAL_URL', payload);
  },
  add_overlay_item({ commit }, payload) {
    commit('ADD_OVERLAY_ITEM', payload);
  },
};
